import {TranscriptionMetadata} from 'molbio/TranscriptionsUtil';

export function transcriptionId(transcription: TranscriptionMetadata): string {
  return `${transcription.rnaSequence.id}-${transcription.start}-${transcription.end}-${transcription.isReverseComplement ? 'rev' : 'fwd'}`;
}
